import React, { ReactElement } from 'react';
import { useSessionUserContext } from '../../../../../../hooks/use-session-user-context';
import { ConnectedLaunchPanelTabContent } from '../LaunchPanelTabContent/container';
import { ConnectedPublicLaunchPanelTabContent } from '../LaunchPanelTabContent/publicContainer';

export function LaunchPanelTabContentWrapper(): ReactElement {
  const { accessKey, sessionUid, versionUid } = useSessionUserContext();

  if (accessKey) {
    return (
      <ConnectedPublicLaunchPanelTabContent
        publicAccessKey={accessKey}
        sessionUid={sessionUid}
        versionUid={versionUid}
      />
    );
  }

  return (
    <ConnectedLaunchPanelTabContent
      sessionUid={sessionUid}
      versionUid={versionUid}
    />
  );
}
